// extracted by mini-css-extract-plugin
module.exports = {"dragDropFile":"styles_dragDropFile__mqDas"};